import { useQuery } from "@tanstack/react-query";
import { aggregateDashboardData } from "../api/dashboardConfig";
import { AggregateRequest } from "../types/dashboard/DashboardConfig";

/**
 * Builds a stable, serialization-safe query key from an AggregateRequest.
 * Strips undefined values (which JSON.stringify omits) to prevent
 * cache misses when null/undefined toggle between renders.
 */
const stableRequestKey = (request: AggregateRequest | null) => {
  if (!request) return null;
  return JSON.stringify(request);
};

export const useDashboardAggregate = (
  customerId: string | undefined,
  request: AggregateRequest | null,
  widgetId: string
) => {
  return useQuery({
    queryKey: ["dashboard-aggregate", customerId, widgetId, stableRequestKey(request)],
    queryFn: () => aggregateDashboardData(customerId!, request!),
    enabled: !!customerId && !!request,
    staleTime: 5 * 60 * 1000, // 5 minutes — widget data doesn't change frequently
  });
};
